import React from "react";
import { Calendar } from "antd";
import {
  DoubleLeftOutlined,
  DoubleRightOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import NotificationWidget from "../widgets/NotificationWidget";

function onPanelChange(value, mode) {}

function RightSideBar({ collapsed, onToggle }) {
  if (collapsed) {
    return (
      <div className="flex flex-col items-center pt-4 space-y-4">
        <button
          type="button"
          onClick={onToggle}
          aria-label="Expand sidebar"
          className="p-2 rounded-full hover:bg-gray-100 cursor-pointer"
        >
          <DoubleLeftOutlined />
        </button>
        <button
          type="button"
          onClick={onToggle}
          aria-label="Expand calendar"
          className="p-2 rounded-full hover:bg-gray-100 cursor-pointer text-xl text-primary"
        >
          <CalendarOutlined />
        </button>
      </div>
    );
  }

  return (
    <>
      <div className="p-2">
        <div className="flex justify-end pr-1">
          <button
            type="button"
            onClick={onToggle}
            aria-label="Collapse sidebar"
            className="p-1 rounded-full hover:bg-gray-100 cursor-pointer"
          >
            <DoubleRightOutlined />
          </button>
        </div>

        <div className="site-calendar-demo-card ">
          <Calendar fullscreen={false} onPanelChange={onPanelChange} />
        </div>

        {/* ------------------------------------------------------------------------------------------------ */}
        <div>
          <div className="flex flex-col pt-6">
            <div className="text-left text-black font-bold text-xl px-2">
              Notification
            </div>

            <div className=" p-2">
              <NotificationWidget />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RightSideBar;
